import {
  Project,
  PullTestPiling,
  PullTestingModule,
} from 'shared_models';

export type OfflineMutationAction =
  | 'installed'
  | 'tensile_tested'
  | 'lateral_tested'
  | 'compression_tested'
  | 'soak_bypassed'
  | 'project_action';

export type OfflineMutationStatus = 'pending' | 'uploading' | 'uploaded' | 'failed';

export interface OfflineMutation {
  id: string;
  pullTestPilingID: string;
  displayPilingId: string;
  action: OfflineMutationAction;
  createdAt: string;
  payload: Record<string, unknown>;
  status: OfflineMutationStatus;
  clientMutationId: string;
}

export interface OfflineActiveSession {
  userId: string;
  projectId: string;
  downloadedAt: string;
}

export interface OfflinePullTestMeta {
  downloadedAt: string;
  totalExpected: number;
  downloadComplete: boolean;
}

export interface OfflinePullTestSnapshot {
  project: Project;
  pullTestingModule: PullTestingModule;
  pilings: PullTestPiling[];
}

export interface OfflineDownloadProgress {
  pilings: PullTestPiling[];
  nextKey: string | null;
}

export interface OfflineTestDraft {
  selectedTestType: string;
  loadStepDrafts: {
    appliedLoadLbs: string;
    deflection1: string;
    deflection2: string;
    deflection3: string;
    comments: string;
  }[];
  updatedAt: string;
}

export interface OfflinePendingListItem {
  displayPilingId: string;
  actionLabel: string;
  createdAt: string;
}

export const OFFLINE_MUTATION_ACTION_LABELS: Record<OfflineMutationAction, string> = {
  installed: 'Installed',
  tensile_tested: 'Tensile tested',
  lateral_tested: 'Lateral tested',
  compression_tested: 'Compression tested',
  soak_bypassed: 'Soak bypassed',
  project_action: 'Audit event',
};

export function offlineActionLabel(action: OfflineMutationAction): string {
  return OFFLINE_MUTATION_ACTION_LABELS[action] ?? action;
}
